/*
  Nono&Friends — o aviso "Avisar-me quando disponível" (app Stoq) por VARIANTE.

  Dois problemas resolvidos aqui.

  1) O aviso não seguia a variante.
     A Stoq injecta o botão uma vez e nunca mais lhe toca. Num artigo com
     várias variantes, bastava escolher uma esgotada para o aviso aparecer — e
     ele ficava preso mesmo depois de se voltar a uma variante com stock, ao
     lado de um "Adicionar ao carrinho" activo.

     Regra, tal como foi pedida:
       - variante SEM stock e SEM "continuar a vender quando esgotado"
           -> mostra o aviso e esconde o botão de compra
       - caso contrário
           -> esconde o aviso e mostra o botão de compra

     Não é preciso ler stock nem política à mão: o `available` do Shopify já é
     essas duas condições juntas, e o tema mantém-no actualizado em
     `data-available` no botão de compra a cada troca de variante (ver
     `_renderBuyButtons` em variant-select.js). Basta segui-lo.

     Por isso a pré-venda não é afectada: esses artigos têm stock 0 mas estão
     em "continuar a vender", logo `available` é verdadeiro e nada muda.

  2) O aviso caía dentro da vista rápida, que está escondida.
     A ficha tem dois `#ProductInfo-…`: o da página e o da vista rápida, que
     existe sempre no DOM mesmo fechada. A Stoq mete o botão no primeiro que
     encontra e, ao entrar directamente por um link `?variant=` de uma
     variante esgotada, calhava na vista rápida — o cliente ficava sem aviso
     nenhum. Quando isso acontece, trazemos o aviso para a ficha visível.

  Segurança: o botão de compra só desaparece se o aviso estiver mesmo lá. Se a
  app não carregar, a ficha volta ao comportamento normal do tema ("Esgotado",
  a cinzento) em vez de ficar sem nada onde clicar.
*/
(function () {
  'use strict';

  var CLASSE_ESCONDER = 'nono-esconder-por-aviso';
  var SEL_FICHA = '[id^="ProductInfo-"]';
  var SEL_AVISO = '.restock-rocket-button-container';
  var SEL_COMPRA = '.x-block-buy-buttons';
  var SEL_ATC = '.add_to_cart_button';
  var SEL_QTD = '.x-quantity-selector';
  var SEL_PAGAMENTO = '.shopify-payment-button';

  var agendado = false;

  function injectarEstilo() {
    if (document.getElementById('nono-aviso-stock-css')) return;
    var s = document.createElement('style');
    s.id = 'nono-aviso-stock-css';
    s.textContent = '.' + CLASSE_ESCONDER + '{display:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }

  function esconder(el, sim) {
    if (el) el.classList.toggle(CLASSE_ESCONDER, !!sim);
  }

  function visivel(el) {
    return !!(el && el.offsetParent !== null);
  }

  /* O aviso só conta se estiver mesmo desenhado: a app cria o contentor
     vazio antes de lhe pôr o botão lá dentro. */
  function avisoPronto(aviso) {
    return !!(aviso && aviso.querySelector('button'));
  }

  function disponivel(ficha) {
    var btn = ficha.querySelector(SEL_COMPRA + ' ' + SEL_ATC + '[data-available]');
    if (!btn) return null;
    return btn.getAttribute('data-available') !== 'false';
  }

  /* Se a app deixou o aviso numa ficha escondida (a vista rápida), trá-lo para
     a ficha que o cliente está a ver, logo a seguir ao botão de compra. */
  function resgatarAviso(ficha) {
    if (ficha.querySelector(SEL_AVISO)) return;

    var avisos = document.querySelectorAll(SEL_AVISO);
    for (var i = 0; i < avisos.length; i++) {
      if (!avisoPronto(avisos[i])) continue;

      var compra = ficha.querySelector(SEL_COMPRA);
      if (compra && compra.parentNode) {
        compra.parentNode.insertBefore(avisos[i], compra.nextSibling);
      } else {
        ficha.appendChild(avisos[i]);
      }
      return;
    }
  }

  function aplicar(ficha) {
    var estado = disponivel(ficha);
    if (estado === null) return;

    if (!estado) resgatarAviso(ficha);
    var aviso = ficha.querySelector(SEL_AVISO);

    /* O aviso segue a variante. */
    esconder(aviso, estado);

    /* O botão de compra só sai de cena se houver aviso a substituí-lo. */
    var esconderCompra = !estado && avisoPronto(aviso);
    esconder(ficha.querySelector(SEL_COMPRA), esconderCompra);
    esconder(ficha.querySelector(SEL_QTD), esconderCompra);
    esconder(ficha.querySelector(SEL_PAGAMENTO), esconderCompra);
  }

  /* Uma ficha fechada não se toca, e limpa-se o que lá tenha ficado: senão a
     vista rápida abria o produto seguinte com o botão de compra já escondido. */
  function limpar(ficha) {
    var presos = ficha.querySelectorAll('.' + CLASSE_ESCONDER);
    for (var i = 0; i < presos.length; i++) {
      presos[i].classList.remove(CLASSE_ESCONDER);
    }
  }

  function aplicarTodas() {
    agendado = false;
    var fichas = document.querySelectorAll(SEL_FICHA);
    for (var i = 0; i < fichas.length; i++) {
      if (visivel(fichas[i])) {
        aplicar(fichas[i]);
      } else {
        limpar(fichas[i]);
      }
    }
  }

  /* A vista rápida e a troca de variante disparam muitas mutações seguidas;
     juntamo-las todas num só passe por frame. */
  function agendar() {
    if (agendado) return;
    agendado = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(aplicarTodas);
    } else {
      setTimeout(aplicarTodas, 0);
    }
  }

  function arrancar() {
    injectarEstilo();
    aplicarTodas();

    /* Troca de variante: o tema já actualizou o data-available quando este
       evento sai (ver _handleUpdateProductInfo). */
    document.addEventListener('eurus:variant:change', agendar);

    /* A app injecta o botão a qualquer momento depois do load, o tema volta a
       desenhar blocos, e a vista rápida enche-se de conteúdo ao abrir. */
    new MutationObserver(function (registos) {
      for (var i = 0; i < registos.length; i++) {
        if (registos[i].addedNodes.length) { agendar(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
